import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Confidentialite() {
  return (
    <div className="rgpd">
      <Navbar />
      <div className="rgpd-content">
        <div className="rgpd-content-block">
          <h1>🔐 Politique de confidentialité – LM Couleurs</h1>
          <p>Dernière mise à jour : juillet 2025</p>
          <p>
            Chez LM Couleurs, nous respectons votre vie privée. Cette politique
            de confidentialité explique comment nous collectons, utilisons et
            protégeons vos données personnelles.
          </p>
        </div>

        <div className="rgpd-content-block">
          <h3>📌 1. Qui sommes-nous ?</h3>
          <ul>
            <li>Nom du site : LM Couleurs</li>
            <li>URL : https://lmcouleurs.fr</li>
            <li>Responsable : Maxime Le Marchand</li>
            <li>Email de contact : lmcouleurs56@gmail.com</li>
          </ul>
        </div>

        <div className="rgpd-content-block">
          <h3>📥 2. Données que nous collectons</h3>
          <p>
            Lorsque vous utilisez notre formulaire de contact, nous pouvons
            collecter les données suivantes :
          </p>
          <ul>
            <li>Nom et prénom</li>
            <li>Adresse e-mail</li>
            <li>Numéro de téléphone</li>
            <li>Contenu du message</li>
          </ul>
          <p>
            Ces données sont transmises volontairement par vos soins pour entrer
            en relation avec nous.
          </p>
        </div>

        <div className="rgpd-content-block">
          <h3>🎯 3. Utilisation des données</h3>
          <p>Les données collectées servent uniquement à :</p>
          <ul>
            <li>Répondre à vos demandes de contact ou de devis</li>
            <li>Vous recontacter dans le cadre d’un projet</li>
          </ul>
          <p>Nous ne vendons ni ne partageons vos données personnelles.</p>
        </div>

        <div className="rgpd-content-block">
          <h3>💾 4. Stockage et sécurité</h3>
          <p>
            Vos données sont stockées de manière sécurisée. Le site est hébergé
            chez Netlify et l’envoi d’e-mails est géré via des services
            sécurisés.
          </p>
          <p>
            Nous utilisons le protocole HTTPS pour protéger la transmission de
            vos données.
          </p>
        </div>

        <div className="rgpd-content-block">
          <h3>⚙️ 5. Vos droits</h3>
          <p>
            Conformément au Règlement Général sur la Protection des Données
            (RGPD), vous disposez des droits suivants :
          </p>
          <ul>
            <li>Accès à vos données personnelles</li>
            <li>Modification ou suppression de vos données</li>
            <li>Opposition à leur traitement</li>
          </ul>
          <p>Pour toute demande : contact@lmcouleurs.fr</p>
        </div>

        <div className="rgpd-content-block">
          <h3>🚫 6. Partage des données</h3>
          <p>
            Aucune donnée personnelle n’est cédée ou partagée à des tiers à des
            fins commerciales ou publicitaires.
          </p>
        </div>

        <div className="rgpd-content-block">
          <h3>✏️ 7. Modifications</h3>
          <p>
            Cette politique peut être modifiée à tout moment. En cas de mise à
            jour importante, vous serez informé via le site.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
